import Card from "components/card";

const Widget = ({ icon, title, subtitle }) => {
  return (
    <Card extra="!flex-row flex-grow items-center rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200">
      <div className="ml-4 flex h-16 w-auto flex-row items-center">
        <div className="rounded-lg bg-gradient-to-br from-blue-50 to-indigo-50 p-2.5 dark:from-blue-900/30 dark:to-indigo-900/30">
          <span className="flex items-center text-blue-600 dark:text-blue-400">
            {icon}
          </span>
        </div>
      </div>

      <div className="h-50 ml-3 flex w-auto flex-col justify-center">
        <p className="font-dm text-xs font-medium text-gray-500 dark:text-gray-400 mb-0.5">{title}</p>
        <h4 className="text-lg font-semibold text-gray-900 dark:text-white">
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;
